module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa027738f54cb246027fc14d5a3e7e076.a027738f.png";